import { Col, Divider, Row } from "antd";
import React, { useEffect, useState } from "react";
import logo from "../../assets/logo/logoRectWhite.svg";
import twitter from "../../assets/icons/x-icon.svg";
import linkedin from "../../assets/icons/likedin-icon.svg";
import instagram from "../../assets/icons/insta-icon.svg";
import youtube from "../../assets/icons/youtube-icon.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import telephone from "../../assets/icons/telephone.svg";
import location from "../../assets/icons/locationFooter.svg";
import email from "../../assets/icons/envelope.svg";
import time from "../../assets/icons/history.svg";
import footerQrImage from "../../assets/images/footerImage.jpg";
const FooterSection = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width < 768;
  const navigate = useNavigate();

  return (
    <div className="takaful--full-footer-container ">
      {/*<HelpSection />*/}

      <Row className="takaful--footer-container">
        <Col xxl={2} xl={2} lg={1} md={1} sm={1} xs={1}></Col>
        <Col xxl={22} xl={22} lg={22} md={22} sm={22} xs={22}>
          <Row gutter={16} style={{ paddingTop: "2vh" }}>
            <Col xxl={7} xl={7} lg={8} md={8} sm={22} xs={22}>
              {/*   <span className="takaful--footer-title-1">
                {t("footer.title1")}
              </span>*/}
            </Col>
            {width > 767 && (
              <>
                <Col xxl={5} xl={5} lg={6} md={6} sm={22} xs={22}>
                  <span className="takaful--footer-title-1">
                    {t("footer.title2")}
                  </span>
                </Col>

                <Col xxl={5} xl={5} lg={7} md={7} sm={22} xs={22}>
                  <span className="takaful--footer-title-1">
                    {t("footer.title3")}
                  </span>
                </Col>
                <Col xxl={4} xl={4} lg={6} md={6} sm={22} xs={22}>
                  <span className="takaful--footer-title-1">
                    {t("footer.title4")}
                  </span>
                </Col>
              </>
            )}
          </Row>

          <Divider className="takaful--footer-divider" />

          <Row gutter={16} style={{ paddingTop: "2vh" }}>
            <Col
              xxl={6}
              xl={6}
              lg={7}
              md={7}
              sm={22}
              xs={22}
              className="takaful--footer-text"
            >
              <img className="takaful--footer-logo" src={logo} alt="logo" />
              <div className="takaful--footer-icon-social">
                <img
                  src={twitter}
                  alt="X"
                  onClick={() =>
                    window.open("https://x.com/takafulsa", "_blank")
                  }
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={linkedin}
                  alt="linkedin"
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9-%D8%AA%D9%83%D8%A7%D9%81%D9%84-%D8%A7%D9%84%D8%AE%D9%8A%D8%B1%D9%8A%D8%A9-%D9%84%D8%B1%D8%B9%D8%A7%D9%8A%D8%A9-%D8%A7%D9%84%D8%A3%D9%8A%D8%AA%D8%A7%D9%85-%D8%A8%D8%A7%D9%84%D9%85%D8%AF%D9%8A%D9%86%D8%A9-%D8%A7%D9%84%D9%85%D9%86%D9%88%D8%B1%D8%A9-45850542",
                      "_blank",
                    )
                  }
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={youtube}
                  alt="X"
                  onClick={() =>
                    window.open("https://www.youtube.com/takafulsa", "_blank")
                  }
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={instagram}
                  alt="X"
                  onClick={() =>
                    window.open("https://www.instagram.com/takafulsa", "_blank")
                  }
                  style={{ cursor: "pointer" }}
                />
              </div>{" "}
            </Col>
            <Col
              className="takaful--footer-link"
              xxl={6}
              xl={6}
              lg={7}
              md={7}
              sm={14}
              xs={14}
            >
              {isMobile && (
                <span className="takaful--footer-title-1">
                  {t("footer.title2")}
                </span>
              )}
              <div className="takaful--footer-dot">
                <ul>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/our-story")}
                  >
                    {t("footer.content.point1")}
                  </li>
                  <li>{t("footer.content.point2")}</li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/organizational-structure")}
                  >
                    {t("footer.content.point3")}
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/our-branches")}
                  >
                    {t("footer.content.point4")}
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    {t("footer.content.point5")}
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/donation-methods")}
                  >
                    {t("footer.content.point6")}
                  </li>
                </ul>
              </div>
            </Col>
            <Col xxl={4} xl={4} lg={6} md={6} sm={9} xs={9}>
              {isMobile && (
                <span className="takaful--footer-title-1">
                  {t("footer.title3")}
                </span>
              )}
              <div className="takaful--footer-dot">
                <ul>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/general-projects")}
                  >
                    {t("footer.content.point11")}
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/programs")}
                  >
                    {t("footer.content.point12")}
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/partners")}
                  >
                    {t("footer.content.point13")}
                  </li>
                  <li>{t("footer.content.point14")}</li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/news")}
                  >
                    {t("footer.content.point15")}
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/contact-us")}
                  >
                    {t("footer.content.point16")}
                  </li>
                </ul>
              </div>
            </Col>
            <Col xxl={3} xl={4} lg={6} md={6} sm={22} xs={22}>
              {isMobile && (
                <span className="takaful--footer-title-1">
                  {t("footer.title4")}
                </span>
              )}
              <div className="takaful--footer-dot">
                <ul>
                  <li>
                    <img
                      src={location}
                      alt="location"
                      style={{ width: "16px", marginLeft: "8px" }}
                    />
                    {t("footer.content.point7")}
                  </li>
                  <li
                    style={{
                      textWrap: "nowrap",
                    }}
                  >
                    <img
                      src={time}
                      alt="time"
                      style={{ width: "16px", marginLeft: "8px" }}
                    />
                    {t("footer.content.point8")}
                  </li>
                  <li>
                    <img
                      src={telephone}
                      alt="telephone"
                      style={{ width: "16px", marginLeft: "8px" }}
                    />
                    {t("footer.content.point9")}
                  </li>
                  <li>
                    <img
                      src={email}
                      alt="email"
                      style={{ width: "16px", marginLeft: "8px" }}
                    />
                    {t("footer.content.point10")}
                  </li>
                </ul>{" "}
                <img alt="" src={footerQrImage} width={220} />
              </div>
            </Col>

            <Col
              className="takaful--footer-social"
              xxl={5}
              xl={5}
              lg={6}
              md={6}
              sm={22}
              xs={22}
            ></Col>
          </Row>
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={1}></Col>
        <Row align={"middle"} className="takaful--footer-copyright-container">
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <div className="takaful--footer-copyright-row">
              <span className="takaful--footer-org-name">
                The Charitable Society for the Care of Orphans in the Madinah
                Region Takaful
              </span>
              <span className="takaful--footer-copyright">
                <p>جميع الحقوق محفوظة</p> <p>©</p>
                تكافل لرعاية الأيتام {currentYear}
              </span>
            </div>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default FooterSection;
